import { useEffect, useRef } from 'react';

export const useCombinedRefs = <T>(
  ...refs: (React.Ref<T> | React.MutableRefObject<T> | undefined | null)[]
): React.RefObject<T> => {
  const targetRef = useRef<T>(null);

  useEffect((): void => {
    refs.forEach((ref): void => {
      if (!ref) return;
      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else {
        (ref as any).current = targetRef.current;
      }
    });
  }, [refs]);

  return targetRef;
};
